import {
  executionStatusGroup,
  collectionStatusOptions,
  deliveryStatusOptions,
  changeStatusOptions,
  billingStatusOptions,
} from '@/model/saleContract';

import * as Moment from 'dayjs';

function convertToName (enums, value) {
  let label = '--';

  for (let v of enums) {
    if (Number(v.value) === Number(value)) {
      label = v.label;
      break;
    }
  }

  return label;
}

export function setSaleContractTable () {
  const saleContractTableCols = [
    {
      title: '合同状态',
      dataIndex: 'state',
      key: 'state',
      width: 140,
      ellipsis: true,
      customRender: text => {
        return convertToName(executionStatusGroup, text);
      },
    },
    {
      title: '合同编号',
      dataIndex: 'pcCode',
      key: 'pcCode',
      width: 180,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '客户抬头',
      dataIndex: 'unit',
      key: 'unit',
      width: 180,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '合同签订日期',
      dataIndex: 'signDate',
      key: 'signDate',
      width: 120,
      ellipsis: true,
      customRender: (text) => {
        return text ? Moment(text).format('YYYY-MM-DD') : '--';
      },
    },
    {
      title: '客户联系人',
      dataIndex: 'saleContractCustomerContact',
      key: 'saleContractCustomerContact',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '收货信息',
      dataIndex: 'receivingName',
      key: 'receivingName',
      width: 220,
      ellipsis: true,
      customRender: (text, row) => {
        let info = row.saleContractReceiverResDTO || {};
        return `${info.name || ''}-${info.phone || ''}-${info.provinceName || ''}${info.cityName || ''}${info.areaName || ''}${info.address || ''}` || '--';
      },
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 180,
      ellipsis: true,
      customRender: (text) => {
        return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
    {
      title: '收款状态',
      dataIndex: 'payState',
      key: 'payState',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return convertToName(collectionStatusOptions, text);
      },
    },
    {
      title: '发货状态',
      dataIndex: 'receivingSts',
      key: 'receivingSts',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return convertToName(deliveryStatusOptions, text);
      },
    },
    {
      title: '开票状态',
      dataIndex: 'billingState',
      key: 'billingState',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return convertToName(billingStatusOptions, text);
      },
    },
    {
      title: '变更状态',
      dataIndex: 'changeState',
      key: 'changeState',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return convertToName(changeStatusOptions, text);
      },
    },
    {
      title: '更新时间',
      dataIndex: 'lastUpdateTime',
      key: 'lastUpdateTime',
      width: 180,
      ellipsis: true,
      customRender: (text) => {
        return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
  ];

  return saleContractTableCols;
}
